import axios from "axios";
import { URL } from "./config";
export const sendOtp = (obj, callback) => {
    const url = `${URL}/sendOtp`;
    axios({
        method: "post",
        url: url,
        data: obj,
    })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.response?.data?.message });
        });
};
export const resendOtp = (obj, callback) => {
    const url = `${URL}/resendOtp`;
    axios({
        method: "post",
        url: url,
        data: obj,
    })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.response?.data?.message });
        });
};
export const verifyOtp = (obj, callback) => {
    const url = `${URL}/verifyOtp`;
    axios({
        method: "post",
        url: url,
        data: obj,
    }).then((response) => {
        if (response?.data) {
            callback({ status: 200, data: response?.data });
        }
    }).catch((error) => {
        callback({ status: 400, message: error?.response?.data?.message });
    });
};
